import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import { data } from './data'
import _ from 'lodash'

const styles = theme => ({
    root: {
        backgroundColor: 'black',
    },
    title: {
        padding: '50px',
        fontWeight: 900
    }
})

function Video(props) {
    const { match, classes } = props
    const id = match.params.id
    // window.scroll({top:0, left:0,behavior: 'smooth'})
    if (id) {
        const index = _.findIndex(data, { 'id': id })
        if (index !== -1) {
            return (
                <div>
                    <div className={classes.root} data-scroll-nav="0">
                        <div style={{ maxWidth: '1100px', height: 564, width: '100%', margin: 'auto' }}>
                            <iframe width={'100%'} height={'100%'} src={data[index].value} frameBorder="0"
                                    allowFullScreen mozallowfullscreen webkitAllowFullScreen></iframe>
                        </div>
                    </div>
                    <div>
                        {/*<Grid container>*/}
                        {/*<Grid item xs={12} md={8}>*/}
                        <Typography variant='title' component={'h1'} className={classes.title}>
                            {data[index].title}
                        </Typography>
                        {/*</Grid>*/}
                        {/*<Grid item xs={12} md={4} style={{padding:'20px'}}>*/}
                        {/*{data.map(d=>{*/}
                        {/*if (d.id !== id) {*/}
                        {/*return(*/}
                        {/*<MediaControlCard*/}
                        {/*title={d.title}*/}
                        {/*link={d.id}*/}
                        {/*src={d.value}*/}
                        {/*/>*/}
                        {/*)*/}
                        {/*}else {*/}
                        {/*return null*/}
                        {/*}*/}
                        {/*})}*/}

                        {/*</Grid>*/}
                        {/*</Grid>*/}
                    </div>
                </div>
            )
        } else {
            return (<div>
                video not Found
            </div>)
        }
    } else {
        return (<div>
            video not Found
        </div>)
    }

}

export default withStyles(styles)(Video)
